module.exports = __webpack_public_path__ + "static/media/01.ddf25ab9.png";